import { Injectable } from '@angular/core';
import { UserRole } from '../models/api-types';
import { AppCapability, canSeeRecordMeta, hasCapability } from './authorization';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  constructor(private auth: AuthService) {}

  getCurrentRole(): UserRole | null {
    return this.auth.getCurrentRole();
  }

  can(capability: AppCapability): boolean {
    return hasCapability(this.getCurrentRole(), capability);
  }

  canAny(capabilities: ReadonlyArray<AppCapability>): boolean {
    return capabilities.some((capability) => this.can(capability));
  }

  canSeeRecordMeta(): boolean {
    return canSeeRecordMeta(this.getCurrentRole());
  }

  getHomeRoute(): string {
    const role = this.getCurrentRole();
    if (!role) {
      return '/login';
    }
    if (role === 'STUDENT') {
      return '/dashboard';
    }
    if (this.can('users:view')) {
      return '/users';
    }
    if (this.can('dashboard:view')) {
      return '/dashboard';
    }
    if (this.can('exercises:view')) {
      return '/exercises';
    }
    if (this.can('scores:view')) {
      return '/scores';
    }
    if (this.can('courses:view')) {
      return '/courses';
    }
    if (this.can('categories:view')) {
      return '/categories';
    }
    if (this.can('progress:view')) {
      return '/progress';
    }
    return '/login';
  }
}
